import { render } from "./HeroiconsSolidCalendar.vue?vue&type=template&id=8419ae0e"
const script = {}

import exportComponent from "/home/tobias/Desktop/screenads/nova-custom2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsSolidCalendar.vue"]])

export default __exports__